import React from 'react';
import Slider from 'react-slick';
import shortid from 'shortid';
import BannerSlider from './BannerSlider';
import CarouselManager from '../../managers/CarouselManager';
import ThumbSlide from './ThumbSlide';

class ImageSlider extends BannerSlider {
  constructor(props) {
    super(props);
    this.settings.autoplay = false;
    this.settings.onInit = () => {
      this.setState({
        showInfo: false,
      });
    };
    const project = new CarouselManager(props.project_id, props.file_path);
    this.projects = project.getCarouselImageManifest();
  }

  render() {
    return (
      <div>
        {super.render()}
        <Slider
          className="project_slide--half_padding_top"
          asNavFor={this.state.nav1}
          ref={(slider) => {
            this.slider2 = slider;
          }}
          slidesToShow={this.projects.length}
          swipeToSlide
          focusOnSelect
        >
          {this.projects.map((project, i) => (
            <ThumbSlide
              key={`ThumbSlide-${shortid.generate()}`}
              project={project}
              index={i}
              slider={this}
            />
          ))}
        </Slider>
      </div>
    );
  }
}

export default ImageSlider;



// WEBPACK FOOTER //
// ./src/components/Sliders/ImageSlider.js